import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

fetch('/_df/status')
  .then((response) => {
    if (!response.ok) {
      throw new Error('Failed to load version.json');
    }
    return response.json();
  })
  .then((status) => {
    console.log('Status', status);

    if (environment.envName !== 'lcl') {
      Sentry.init({
        dsn: environment.sentryDsn,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        tracesSampleRate: 1,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1,
        sendDefaultPii: true,
        environment: environment.envName,
        release: status.tag,
        debug: environment.envName === 'dev',
        maxBreadcrumbs: 10,
      });
    }

    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
  })
  .catch((err) => {
    console.error('Could not load version.json', err);
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
  });
